module.exports = __webpack_public_path__ + "img/AramKakayFalah-SharbatiTrs.4ce22489.jpg";